import type { ReceiptMoment } from './share';

export type ShareableWatchlistAdoption = {
  changedSinceLastVisit?: boolean;
  latestReceiptMoment?: ReceiptMoment | null;
};

export function getShareableChangedAdoptions<T extends ShareableWatchlistAdoption>(adoptions: T[]): Array<T & { latestReceiptMoment: ReceiptMoment }> {
  return adoptions
    .filter((adoption): adoption is T & { latestReceiptMoment: ReceiptMoment } => (
      Boolean(adoption.changedSinceLastVisit) &&
      Boolean(adoption.latestReceiptMoment)
    ))
    .sort((a, b) => b.latestReceiptMoment.occurredAt - a.latestReceiptMoment.occurredAt);
}
